/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    SaveRoute,
    EditRoute,
    GetAllGroupsForDropDown,
    GetAllRoutesByGroupID,
    GetRouteDetails,
    GetRouteMappingDetails,
    GetUserAgentsByGroupID,
    GetVehicleByGroupID,
    GetVehicleRouteMappingByRouteID,
    DeleteVehicleRouteMapping,
};

async function SaveRoute(values) {
    const response = await CommonPost('/api/Routes/SaveRoute', null, values);
    return response;

}

async function EditRoute(values) {
    const response = await CommonPost('/api/Routes/UpdateRoute', null, values);
    return response;

}

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllRoutesByGroupID(groupID) {
    const response = await CommonGet('/api/Routes/GetAllRoutesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetUserAgentsByGroupID(groupID) {
    const response = await CommonGet('/api/User/GetUserAgentsByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetRouteDetails(routeID) {
    const response = await CommonGet('/api/Routes/GetRouteDetails', 'routeID=' + parseInt(routeID));
    return response.data;
}

async function GetRouteMappingDetails(routeID) {
    const response = await CommonGet('/api/Routes/GetRouteMappingDetails', 'routeID=' + parseInt(routeID));
    return response.data;
}

async function GetVehicleByGroupID(groupID) {
    const response = await CommonGet('/api/VehicleMaster/GetVehicleByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetVehicleRouteMappingByRouteID(routeID) {
    const response = await CommonGet('/api/Routes/GetVehicleRouteMappingByRouteID', 'routeID=' + parseInt(routeID));
    return response.data;
}

async function DeleteVehicleRouteMapping(vehicleRouteMappingID,userID) {
    const response = await CommonGet('/api/Routes/DeleteVehicleRouteMappingData', 'vehicleRouteMappingID=' + parseInt(vehicleRouteMappingID) + '&' + 'modifiedBy=' + parseInt(userID) );
    return response.data;
}
